import Breadcrumbs from '@mui/material/Breadcrumbs';
import Button from '@mui/material/Button';
import Chip from '@mui/material/Chip';
import Grid from '@mui/material/Grid';
import InputLabel from '@mui/material/InputLabel';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import Container from '@mui/system/Container';
import Stack from '@mui/system/Stack';
import Master from 'front/MasterAdmin';
import React from 'react';
import { useSelector } from 'react-redux';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { hasErrors } from '../../../common/enums';
import { Franchise } from '../../../common/models/franchise';
import { userLogged } from '../../../common/selectors/user';
import { editFranchiseSlice } from '../../../common/store/editFranchiseSlice';
import { franchiseSlice } from '../../../common/store/franchises';
import { AppState, appStore, franchiseSelector } from '../../../common/store/store';
import { postData } from '../../api';
import { Loading } from '../Loading';

import Editor from '../../front/CLIENT_RichTextEditor';

export const EditFranchise = () => {

    const { id } = useParams();

    const user = useSelector((state: AppState) => userLogged(state));

    const [loading, setLoading] = React.useState(false);
    const franchise = useSelector((state: AppState) => franchiseSelector.selectById(state, parseInt(id ?? '0')));
    const editingFranchise = useSelector((state: AppState) => state.editFranchise.franchise);
    const newPointDeService = useSelector((state: AppState) => state.admin.newPointDeService);

    const [err, setErr] = React.useState<ResponseError[] | undefined>();
    const navigate = useNavigate();
    React.useEffect(() => {
        if (franchise) {
            appStore.dispatch(editFranchiseSlice.actions.update(franchise));
        }
    }, []);


    const onSaveClick = async () => {
        setLoading(true);
        try {
            const result = await postData<Franchise>('franchises', editingFranchise);
            if (!hasErrors(result)) {
                setErr(undefined);
                appStore.dispatch(editFranchiseSlice.actions.update(result));
                appStore.dispatch(franchiseSlice.actions.upsertOne(result));
            } else {
                setErr(result);
            }
            setLoading(false);
        } catch (err) {
            alert('Un erreur a eu lieu');
            setLoading(false);
        }
    };

    if (!franchise) return <p>Not found</p>;

    return <Master>
        <Container maxWidth={false}>
            <Typography variant='h1'>{franchise.name}</Typography>
            {user?.isAdmin ? <Breadcrumbs>
                <Link to={'/admin/franchises'} onClick={() => { navigate('/admin/franchises'); }}>Franchises</Link>
                <Typography>{franchise.name}</Typography>
            </Breadcrumbs> : null}
            {loading ? <Loading /> : null}
            <Grid container columns={2}>

                <Grid item xs={2} sm={1} sx={{ p: 2 }}>
                    <Typography variant='h2'>Informations générales</Typography>
                    <Stack spacing={2}>
                        <TextField
                            fullWidth
                            label='Nom de la franchise'
                            name='name'
                            value={editingFranchise.name ?? ''}
                            onChange={(event) => {
                                appStore.dispatch(editFranchiseSlice.actions.update({ name: event.target.value }));
                            }}
                            error={!!err?.find(p => p.param === 'name')}
                            helperText={err?.find(p => p.param === 'name')?.msg}
                        />
                        <TextField
                            fullWidth
                            label='Code de la franchise'
                            name='code'
                            value={editingFranchise.code ?? ''}
                            onChange={(event) => {
                                appStore.dispatch(editFranchiseSlice.actions.update({ code: event.target.value }));
                            }}
                            error={!!err?.find(p => p.param === 'code')}
                            helperText={err?.find(p => p.param === 'code')?.msg}
                        />
                        <InputLabel><input
                            type="color"
                            name="color"
                            value={editingFranchise.color ?? ''}
                            onChange={(event) => {
                                const color: string = event.target.value.startsWith('#') ? event.target.value : '#' + event.target.value;
                                appStore.dispatch(editFranchiseSlice.actions.update({ color: color }));
                            }}
                        /> Couleur</InputLabel>
                        <TextField
                            fullWidth
                            label='Nom de la personne contact'
                            name='contactName'
                            value={editingFranchise.contactName ?? ''}
                            onChange={(event) => {
                                appStore.dispatch(editFranchiseSlice.actions.update({ contactName: event.target.value }));
                            }}
                            error={!!err?.find(p => p.param === 'contactName')}
                            helperText={err?.find(p => p.param === 'contactName')?.msg}
                        />

                        <TextField
                            fullWidth
                            label='Adresse courriel de contact'
                            name='email'
                            value={editingFranchise.email ?? ''}
                            onChange={(event) => {
                                appStore.dispatch(editFranchiseSlice.actions.update({ email: event.target.value }));
                            }}
                            type='email'
                            error={!!err?.find(p => p.param === 'email')}
                            helperText={err?.find(p => p.param === 'email')?.msg}
                        />
                        <TextField
                            fullWidth
                            label='Numéro de téléphone'
                            name='tel'
                            value={editingFranchise.tel ?? ''}
                            onChange={(event) => {
                                appStore.dispatch(editFranchiseSlice.actions.update({ tel: event.target.value }));
                            }}
                            type='text'
                            error={!!err?.find(p => p.param === 'tel')}
                            helperText={err?.find(p => p.param === 'tel')?.msg}
                        />
                        <TextField
                            fullWidth
                            label='Adresse physique'
                            name='address'
                            value={editingFranchise.address ?? ''}
                            onChange={(event) => {
                                appStore.dispatch(editFranchiseSlice.actions.update({ address: event.target.value }));
                            }}
                            error={!!err?.find(p => p.param === 'address')}
                            helperText={err?.find(p => p.param === 'address')?.msg}
                        />

                        <TextField
                            fullWidth
                            label='Page facebook'
                            name='facebookUrl'
                            value={editingFranchise.facebookUrl ?? ''}
                            onChange={(event) => {
                                appStore.dispatch(editFranchiseSlice.actions.update({ facebookUrl: event.target.value }));
                            }}
                            type="url"
                            error={!!err?.find(p => p.param === 'facebookUrl')}
                            helperText={err?.find(p => p.param === 'facebookUrl')?.msg}
                        />
                        <TextField
                            fullWidth
                            label='Lien google maps'
                            name='googleMapUrl'
                            value={editingFranchise.googleMapUrl ?? ''}
                            onChange={(event) => {
                                appStore.dispatch(editFranchiseSlice.actions.update({ googleMapUrl: event.target.value }));
                            }}
                            type="url"
                            error={!!err?.find(p => p.param === 'googleMapUrl')}
                            helperText={err?.find(p => p.param === 'googleMapUrl')?.msg}
                        />
                    </Stack>
                </Grid>
                <Grid item xs={2} sm={1} sx={{ p: 2 }}>
                    <Typography variant='h2'>SEO / Site Web</Typography>
                    <Stack spacing={2}>
                        <TextField
                            disabled={user?.email !== 'sdion@constructioncdx.com'}
                            fullWidth
                            label='Alias à utiliser'
                            name='alias'

                            value={editingFranchise.alias ?? ''}
                            onChange={(event) => {
                                appStore.dispatch(editFranchiseSlice.actions.update({ alias: event.target.value }));
                            }}
                            error={!!err?.find(p => p.param === 'alias')}
                            helperText={err?.find(p => p.param === 'alias')?.msg ?? (user?.email !== 'sdion@constructioncdx.com' ? `Pour changer cet alias, communiquer avec Simon` : null)}
                            InputProps={{
                                endAdornment: <Chip label='.pieuxprotech.ca' />
                            }}
                        />
                        <TextField
                            fullWidth
                            multiline
                            rows={2}

                            label='Titre affiché par défaut'
                            name='defaultTitle'

                            value={editingFranchise.defaultTitle ?? ''}
                            onChange={(event) => {
                                appStore.dispatch(editFranchiseSlice.actions.update({ defaultTitle: event.target.value }));
                            }}
                            error={!!err?.find(p => p.param === 'defaultTitle')}
                            helperText={err?.find(p => p.param === 'defaultTitle')?.msg}
                        />
                        <TextField
                            fullWidth
                            multiline
                            rows={6}

                            label='Description affiché par défaut'
                            name='defaultDescription'

                            value={editingFranchise.defaultDescription ?? ''}
                            onChange={(event) => {
                                appStore.dispatch(editFranchiseSlice.actions.update({ defaultDescription: event.target.value }));
                            }}
                            error={!!err?.find(p => p.param === 'defaultDescription')}
                            helperText={err?.find(p => p.param === 'defaultDescription')?.msg}
                        />
                        <label>Points de service</label>
                        <Editor
                            html={franchise.pointsDeService ?? ''}
                            onChange={(e) => {
                                appStore.dispatch(editFranchiseSlice.actions.update({ pointsDeService: e.target.value }));
                            }}
                            className="dark white" />
                    </Stack>
                </Grid>
                <Grid item xs={2} sx={{ p: 2, textAlign: 'center' }}>
                    <label>Texte d'accueil</label>
                    <Editor
                        html={franchise.homeText ?? ''}
                        onChange={(e) => {
                            appStore.dispatch(editFranchiseSlice.actions.update({ homeText: e.target.value }));
                        }}
                        className="dark header" />
                </Grid>

                <Grid item xs={2} sx={{ p: 2, textAlign: 'center' }}>
                    <Button disabled={loading} size='large' variant='contained' onClick={onSaveClick}>Sauvegarder</Button>
                </Grid>
            </Grid>
        </Container>
    </Master>;
};
